import { render, staticRenderFns } from "./ConstrutorDeRelatorio.vue?vue&type=template&id=d042b3dc&scoped=true&"
import script from "./ConstrutorDeRelatorio.vue?vue&type=script&lang=ts&"
export * from "./ConstrutorDeRelatorio.vue?vue&type=script&lang=ts&"
import style0 from "./ConstrutorDeRelatorio.vue?vue&type=style&index=0&id=d042b3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d042b3dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VBtnToggle,VCard,VCheckbox,VChip,VIcon,VMenu,VSelect,VSpacer,VTextField,VTooltip})
